import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Container as Grid } from 'react-bootstrap'
import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'

import { getQuestionAccuracy } from '../../../shared/lib/calculateAccuracy'

import AutoFocus from '../AutoFocus'
import PieChart from '../Instructor/PieChart'
import { Modal } from 'react-bootstrap'

import closeImg from 'Assets/x-icon-gray.svg'

import buttonStyle from 'Styles/button.css'
import style from './style.css'

export default function CompletedActivityModal (props) {
  const questionAccuracy = getQuestionAccuracy(props.activityTopics)
  const retakeAccuracy = props.isRetake ? getQuestionAccuracy(props.isRetake.topics) : null
  const modalHeader = !props.isRetake
    ? 'Assignment Completed!'
    : retakeAccuracy < questionAccuracy ? 'You\'ve Improved Your Understanding!' : 'Keep Practicing!'
  const congratsText = !props.isRetake
    ? 'Your grade has been recorded, but the study plan shows where you struggled. ' +
  'Reread those sections and then you can retake the quiz for practice. '
    : 'Your grade isn\'t affected, but by rereading what you don\'t understand and retaking ' +
  'the quiz you deepen your knowledge.'

  function renderCoachButton () {
    if (props.coachButtonText) {
      return (
        <div>
          <button
            className={classnames(buttonStyle.rectangle, style.coachButton, 'btn-cdl-main')}
            onClick={props.onClickCoachButton}
          >
            {props.coachButtonText}
          </button>
        </div>
      )
    }
  }

  function pieChartSlices (questionAccuracy) {
    let chartColor

    if (questionAccuracy < 70) {
      chartColor = '#DA1B2C' // --prs-c-red-500
    } else if (questionAccuracy >= 70 && questionAccuracy < 90) {
      chartColor = '#E5D676' // --prs-c-yellow-400
    } else { // percentage >= 90
      chartColor = '#68B75F' // --prs-c-green-400
    }
    return (
      [
        {
          color: '#fff',
          value: 100 - questionAccuracy
        },
        {
          color: chartColor,
          value: questionAccuracy
        }
      ]
    )
  }

  let originalPieChart

  if (retakeAccuracy) {
    originalPieChart = (
      <div className={style.accuracyCol}>
        <div className={style.chartTitle}>Quiz Results</div>
        <div className={classnames(style.accuracySpan)}>
          <span
            data-test-id="completedModalAccuracy"
            className={style.percent}
          >
            {retakeAccuracy}%
          </span>
          <span className={style.accuracyText}> accuracy</span>
        </div>
        <PieChart
          slices={pieChartSlices(retakeAccuracy)}
          borderColor={'#C8C8C8'} // --prs-c-gray-400
          instanceClass={style.accuracyPieChart}
        />
      </div>
    )
  }

  return (
    <Modal show={true}>
      <div
        data-test-id="lcrpQuizCompleteModal"
        className={classnames(style.contentWrapper, 'row')}
      >
        <div className={style.fullWidth}>
          <button
            className={classnames(buttonStyle.rectangle, style.hideModal)}
            onClick={props.onClick}
          >
            <img
              src={closeImg}
              alt="Close this message"
              className={style.closeIcon}
            />
          </button>
          <AutoFocus>
            <h3 className={style.congratulationText}>{modalHeader}</h3>
            <p className={style.textInfoModal}>
              {congratsText}<br /><br />
            </p>
            {renderCoachButton()}
          </AutoFocus>
        </div>
        <Grid className={style.chartContainer}>
          <Row>
            <Col xs={retakeAccuracy ? 6 : 0}>
              {originalPieChart}
            </Col>
            <Col xs={retakeAccuracy ? 6 : 12}>
              <div className={style.accuracyCol}>
                <div className={style.chartTitle}>{retakeAccuracy ? 'Practice Retake' : 'Quiz Results'}</div>
                <div className={classnames(style.accuracySpan)}>
                  <span className={style.percent}> {questionAccuracy}%</span>
                  <span className={style.accuracyText}> accuracy</span>
                </div>
                <PieChart
                  slices={pieChartSlices(questionAccuracy)}
                  borderColor={'#C8C8C8'} // --prs-c-gray-400
                  instanceClass={style.accuracyPieChart}
                />
              </div>
            </Col>
          </Row>
        </Grid>
        <div>
          <button
            data-test-id="completedModalViewPlanBtn"
            className={classnames('btn-cdl-main', style.studyPlanButton)}
            onClick={props.onBacktoStudyClick}
          >
            View Study Plan
          </button>
        </div>
      </div>
    </Modal>
  )
}

CompletedActivityModal.propTypes = {
  onClick: PropTypes.func.isRequired,
  onBacktoStudyClick: PropTypes.func.isRequired,
  coachButtonText: PropTypes.string,
  onClickCoachButton: PropTypes.func,
  activityTopics: PropTypes.array.isRequired,
  isRetake: PropTypes.object
}
